import type { ConsentTypeCode } from '@/lib/api/consents/types';

export type ConsentFormValues = {
  electronicDelivery: boolean;
  textAlerts: boolean;
  automatedCalling: boolean;
  mobilePhone: string;
};

type CheckboxField = 'electronicDelivery' | 'textAlerts' | 'automatedCalling';

const CHECKBOX_FIELD_BY_CONSENT_TYPE: Record<ConsentTypeCode, CheckboxField> = {
  ELECTRONIC_DELIVERY: 'electronicDelivery',
  TRANSACTIONAL_SMS: 'textAlerts',
  AI_CALLING: 'automatedCalling',
};

export const isChecked = (consentType: ConsentTypeCode, values: ConsentFormValues): boolean =>
  values[CHECKBOX_FIELD_BY_CONSENT_TYPE[consentType]];

export const toggleConsentField = (
  values: ConsentFormValues,
  consentType: ConsentTypeCode
): ConsentFormValues => {
  const field = CHECKBOX_FIELD_BY_CONSENT_TYPE[consentType];
  return { ...values, [field]: !values[field] };
};
